import ApiService from "./ApiService"

export default {
    search(reportId, search) {
        let params = new URLSearchParams();
        if(search.output)
            params.append('output', search.output);
        let qs = params.toString();
        if(qs && qs.length > 0)
             qs = "?" + qs;
        return ApiService().get(`api/reports/${reportId}/details/${search.offset}/${search.limit}${qs}`);
    },
    get(reportId, id) {
        return ApiService().get(`api/reports/${reportId}/details/${id}`);
    },
    put(reportId, id, payload) {
        return ApiService().put(`api/reports/${reportId}/details/${id}`, payload);
    },
    post(reportId, payload) {
        return ApiService().post(`api/reports/${reportId}/details`, payload);
    },
    delete(reportId, id) {
        return ApiService().delete(`api/reports/${reportId}/details/${id}`, {});
    }
}